import type { FormFieldDeclarationsForValidationDepsTrigger } from "./types";

/**
 * Собирает карту «имя поля → имена полей для `trigger`» из {@link FormFieldDeclarationsForValidationDepsTrigger} по `validation.deps`. \
 * Используется `BusinessForm` после `setValue` с валидацией, чтобы кросс-полевые правила обновляли ошибки у соседних полей (RHF по умолчанию триггерит только изменённое поле).
 *
 * @template TForm тип значений формы
 * @param fieldDeclarations декларации из {@link defineFormConfig} / {@link defineFilterConfig}; при `undefined` (например {@link formConfigFromSchema}) возвращается `{}`.
 * @returns только ключи с непустым `deps`
 */
export function buildSetValueValidationDepsMap<TForm extends object>(
    fieldDeclarations: FormFieldDeclarationsForValidationDepsTrigger<TForm> | undefined,
): Partial<Record<Extract<keyof TForm, string>, readonly string[]>> {
    if (fieldDeclarations === undefined) {
        return {};
    }
    const out: Partial<Record<Extract<keyof TForm, string>, readonly string[]>> = {};
    for (const key of Object.keys(fieldDeclarations) as Extract<keyof TForm, string>[]) {
        const deps = fieldDeclarations[key]?.validation?.deps;
        if (deps != null && deps.length > 0) {
            out[key] = deps;
        }
    }
    return out;
}
